import { createSlice } from "@reduxjs/toolkit";
import {app} from '../../Firebase/Firebaseapp'
import { signOut,getAuth } from 'firebase/auth'


const auth =getAuth(app)

const AuthSlice =createSlice({
    name:"Authtentation",
    initialState:{
       user:"",
       UpdateDepe:false, 
    },
    reducers:{
        SigninUser(state,action){
            state.user=action.payload
        },
        SignoutUser(state){
            signOut(auth) 
            state.user=""
        },
        UpdateDependency(state){
            state.UpdateDepe=!state.UpdateDepe
        },  
        
    }
    
})

export default AuthSlice.reducer


export const {SigninUser,SignoutUser,UpdateDependency,OneTimeLogin}=AuthSlice.actions